
import React from 'react';

const SchoolInformation = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-3xl font-bold mb-4"><strong>School Contact Information</strong></h2>
        <p className="mb-4">
          The Cee Bee Corporate Centre<br />
          The Centreville Medical Pavilion
        </p>
        <p className="mb-4">
          72 Collins Avenue,<br />
          P.O. Box N-4296<br />
          Nassau, Bahamas
        </p>
        <p className="mb-4">
          <a href="mailto:info@hcbahamas.com" className="text-blue-500 underline">info@hcbahamas.com</a>
        </p>
        <hr className="my-4" />

        <h2 className="text-3xl font-bold mb-4"><strong>Physical Facility</strong></h2>
        <p className="mb-4">
          Hamilton College of the Bahamas is headquartered at The Cee Bee Corporate Centre, 72 Collins Avenue, P.O. Box N-4296, Nassau, Bahamas. All programs and courses are deployed via the internet and small groups in selected areas.
        </p>
      </div>
    </div>
  );
};

export default SchoolInformation;